import React, { useEffect, useRef, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { color, motion, transform, useInView } from "framer-motion";
import Link from "../../components/v2/Link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import clsx from "clsx";

import BanImg1 from "../../images/v4/user-based-tools/emailMarketing/images/BanImg1.webp";
import BanImg2 from "../../images/v4/user-based-tools/emailMarketing/images/BanImg2.webp";
import BanImg3 from "../../images/v4/user-based-tools/emailMarketing/images/BanImg3.webp";
import BanImg4 from "../../images/v4/user-based-tools/emailMarketing/images/BanImg4.webp";
import BanImg5 from "../../images/v4/user-based-tools/emailMarketing/images/BanImg5.webp";
import BanImg6 from "../../images/v4/user-based-tools/emailMarketing/images/BanImg6.webp";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import benefitIcon1 from "../../images/v4/user-based-tools/emailMarketing/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/user-based-tools/emailMarketing/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/user-based-tools/emailMarketing/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/user-based-tools/emailMarketing/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/user-based-tools/emailMarketing/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/user-based-tools/emailMarketing/icons/benefitIcon6.svg";

import compareItemImg1 from "../../images/v4/whatsappCatalogue/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg5 from "../../images/v4/user-based-tools/emailIntegration/images/compareItemImg3.png";

import broadcastImg1 from "../../images/v4/user-based-tools/emailMarketing/images/broadcastImg1.webp";
import broadcastImg2 from "../../images/v4/user-based-tools/emailMarketing/images/broadcastImg2.webp";

import experienceImg from "../../images/v4/user-based-tools/emailMarketing/images/experienceImg.webp";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import salesReppageHerobg from "../../images/v4/TgPages/marketting/heroBg.png";
import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import clientbg from "../../images/v4/TgPages/salesDevReps/clientBg.png";

import benefitSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/benefitSectionBg.png";
import heroSectionBg from "../../images/v4/user-based-tools/emailMarketing/images/heroSectionBg.png";
import heroSectionBgMob from "../../images/v4/user-based-tools/emailMarketing/images/heroSectionBgMob.png";
import broadcastBg from "../../images/v4/user-based-tools/messagingCommunication/images/broadcastBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";
import experienceBg from "../../images/v4/user-based-tools/messagingCommunication/images/experienceBg.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";

const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${heroSectionBg})`,
    backgroundColor: "#210538",
    backgroundPosition: "center",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
    },
    "@media only screen and (max-width: 600px)": {
       backgroundImage: `url(${heroSectionBgMob})`,
     }
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    "& h1": {
      margin: "0",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {},
  },
  Client: {
    position: "relative",
    zIndex: "10",
    backgroundImage: `url(${clientbg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(max-width:1024px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "25px!important",
        },
      },
    },

    "@media(max-width:600px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "20px!important",
        },
      },
    },

    "& p": {
      textAlign: "center",
      marginBottom: "64px",
      "@media(max-width:1024px)": {
        marginBottom: "32px",
      },

      "@media(max-width: 600px)": {
        marginBottom: "18px",
      },
    },
    "& .client-logo": {
      width: "auto!important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "35px",
      },
    },
  },
  benefitSection2: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      "& h2": {
        width: "100%",
      },
      "& p": {
        textAlign: "left",
        width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        gap: "16px",
        "& h2": {
          width: "100%",
          textAlign: "left",
        },
        "& p": {
          textAlign: "left",
          width: "100%",
        },
      },
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  benefitBox: {
    display: "flex",
    border: "1px solid #208EEC",
    background: "rgba(32, 142, 236, 0.15)",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "16px",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },
  accordianTabs: {
    position: "relative",
    paadingBottom: "0",
    "& .headercenterContainer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
      width: "80%",
      margin: "0 auto",
      marginBottom: "64px",
      textAlign: "center",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "70%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "20px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  experienceContainer: {
    backgroundImage: `url(${experienceBg})`,
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "25px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#1D6FB6",
      marginBottom: "20px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
      "& .exp-desc": {
        marginBottom: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      // display: "none",
      width: "100%",
      minHeight: "unset",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "transparent",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.30)",
    },
    "&:before": {
      borderRadius: "0 0 4px 4px",
      content: '""',
      position: "absolute",
      background: "linear-gradient(180deg,#B1DBFF 0%, #fff 0%, #0089FF 100% )",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "8px",
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",

    "& img": {
      width: "24px",
      height: "24px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  broadcastContainer: {
    backgroundImage: `url(${broadcastBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $broadcastRightContainer": {
      width: "50%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },
  workflowBroadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "stretch",
    gap: "30px",
    padding: "0 4rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "40px",
    background: "#009249",
    alignItems: "center",
    borderRadius: "20px",
    justifyContent: "space-between",
    minWidth: "70%",
    maxWidth: "70%",
    minHeight: "400px",
    maxHeight: "400px",
    // minHeight: "415px",
    // maxHeight: "415px",
    transition: "0.3s ease",
    overflow: "hidden",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px",
      gap: "15px",
      flexDirection: "column-reverse",
      minHeight: "770px",
      justifyContent: "flex-end",
      minWidth: "90%",
      maxWidth: "90%",
    },
    "@media only screen and (min-width: 1800px)": {
      minWidth: "80%",
      maxWidth: "80%",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "55%",
    gap: "10px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "flex-start",
    },
  },
  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
}));

const EmailMarketing = () => {
  const classes = useStyles();

  const bannerlogotrack2 = [
    { img: BanImg1, alt: "Omnichannel CRM for multi-platform management" },
    { img: BanImg2, alt: "Unified CRM for all channels" },
    { img: BanImg3, alt: "CRM system integrates communications" },
  ];
  const bannerlogotrack3 = [
    { img: BanImg4, alt: "WhatsApp business integration in CRM" },
    { img: BanImg5, alt: "Connect WhatsApp to CRM software" },
    { img: BanImg6, alt: "How to link WhatsApp CRM" },
    // { img: BanImg7 },
    // { img: BanImg8 },
  ];
  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];
  const benefits = [
    {
      title: "Easy field mapping",
      desc: "Map Mailchimp or MailerLite fields to CRM quickly to ensure accurate, clean, and customised data setup.",
      icon: benefitIcon1,
    },
    {
      title: "Two-way sync",
      desc: "Changes in CRM or email tools sync automatically, keeping your data accurate and up to date.",
      icon: benefitIcon2,
    },
    {
      title: "Campaign insights live",
      desc: "Track opens, clicks, and conversions from Mailchimp or MailerLite directly inside your CRM for better decisions.",
      icon: benefitIcon3,
    },
    {
      title: "Workflow automation triggers",
      desc: "Trigger email campaigns based on CRM activity like signups or status changes—automatically and at the right moment.",
      icon: benefitIcon4,
    },
    {
      title: "Advanced list segmentation",
      desc: "Use CRM filters to segment contacts and sync with email tools for highly targeted, relevant campaigns.",
      icon: benefitIcon5,
    },
    {
      title: "Unified customer view",
      desc: "Combine email data with WhatsApp, calls, and deals to engage contacts with a fully informed, personalised approach.",
      icon: benefitIcon6,
    },
  ];

  useEffect(() => {
    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".banner-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "top";
        if (this.track) {
          this.init();
        }
      }

      init() {
        // Store original children so we always clone from a clean copy
        const originalItems = Array.from(this.track.children).map((child) =>
          child.cloneNode(true)
        );
        if (!originalItems.length) return;

        const containerHeight = this.row.offsetHeight;
        let currentHeight = this.track.offsetHeight;

        // Fill until track height is at least twice container height
        while (currentHeight < containerHeight * 2) {
          originalItems.forEach((clone) => {
            this.track.appendChild(clone.cloneNode(true));
          });
          currentHeight = this.track.offsetHeight;
        }

        // Set initial scroll position
        if (this.direction === "top") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetHeight / 2;
        }

        this.animate();
      }

      animate() {
        const animateStep = () => {
          if (this.direction === "top") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetHeight / 2) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = -this.track.offsetHeight / 2;
            }
          }
          this.track.style.transform = `translateY(${this.position}px)`;
          requestAnimationFrame(animateStep);
        };

        requestAnimationFrame(animateStep);
      }
    }

    if (typeof window !== "undefined") {
      document.querySelectorAll(".logos-row").forEach((row) => {
        const speed = parseFloat(row.dataset.speed) || 0.5;
        new InfiniteScroll(row, speed);
      });
    }
  }, []);

  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  const experienceList = [
    {
      title: "Accurate, up-to-date customer data",
      alt: "CRM and email contact sync with latest customer data",
      desc: "Automatically sync contact data between your CRM and email platforms to eliminate manual updates and always work with the latest customer information.",
    },
    {
      title: "Smarter segmentation and targeting",
      alt: "CRM-powered audience filters and advanced targeting",
      desc: "Use CRM filters, lead stages, and behavioural insights to create highly focused audience segments for more relevant, timely emails and increased engagement.",
    },
    {
      title: "Personalised customer journeys",
      alt: "Personalised email journeys informed by CRM data",
      desc: "Send tailored campaigns based on customer preferences, past activity, or buying behaviour by combining CRM insights with email tools, driving loyalty and conversions.",
    },
    {
      title: "Campaign automation with CRM triggers",
      alt: "Automated email sequences triggered by CRM updates",
      desc: "Trigger automated email sequences directly from your CRM based on actions like signups, deal stage updates, or event responses for consistent, timely communication.",
    },
    {
      title: "Real-time campaign analytics in your CRM",
      alt: "Email campaign performance and analytics within CRM",
      desc: "Track email opens, clicks, and conversions right from your CRM dashboard, enabling your team to measure results and quickly adjust campaign strategies.",
    },
  ];

  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track?.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "HubSpot CRM",
    "Salesforce",
    "ActiveCampaign CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM offers seamless integration with leading email marketing platforms like Mailchimp and MailerLite. Built for modern businesses, it helps you automate outreach, personalise communication, and make faster, data-driven decisions — all within one unified platform.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "Two-way data synchronisation",
          desc: "Automatically update contacts between your CRM and email platforms to keep records clean and current.",
        },
        {
          title: "Flexible field mapping",
          desc: "Easily map Mailchimp or MailerLite fields to CRM fields, ensuring accurate data alignment from day one.",
        },
        {
          title: "Real-time email campaign insights",
          desc: "Track email opens, clicks, and conversions from your CRM dashboard to evaluate performance quickly.",
        },
        {
          title: "Workflow automation",
          desc: "Trigger personalised email campaigns based on CRM activities like lead creation, deal stage changes, or event signups.",
        },
        {
          title: "Advanced segmentation tools",
          desc: "Use CRM filters to create dynamic, targeted audience lists and sync them with your email platform for better campaign precision.",
        },
        {
          title: "Eliminates manual data entry",
          desc: "Reduce errors and save time by automating the data flow between your CRM and email tools.",
        },
        {
          title: "360-degree customer view",
          desc: "See email engagement alongside sales, WhatsApp, and support interactions in one place for stronger, context-rich communication.",
        },
        {
          title: "Get started",
          desc: "",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers tight integration with Zoho Campaigns and other email platforms, making it ideal for businesses already in the Zoho ecosystem. It’s highly customisable and suitable for mid-sized to large teams.",
      img: compareItemImg2,
      alt: "Zoho CRM",
      features: [
        {
          title: "Built-in Zoho Campaigns integration",
          desc: "Quickly set up email marketing directly within your CRM platform.",
        },
        {
          title: "Advanced scoring rules",
          desc: "Use lead nurturing and scoring to segment audiences and boost campaign responsiveness.",
        },
        {
          title: "Visual email workflows",
          desc: "Drag-and-drop workflow builder using CRM triggers to automate email sends and follow-ups.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "A leading name in inbound marketing, HubSpot CRM offers a robust all-in-one solution. Its email marketing tools are native, powerful, and deeply integrated with CRM records and automation.",
      img: compareItemImg3,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Native email builder",
          desc: "Create beautiful, personalised emails using HubSpot’s smart builder and dynamic content.",
        },
        {
          title: "Behaviour-triggered workflows",
          desc: "Automate emails based on contact behaviour or CRM events for timely communication.",
        },
        {
          title: "Detailed contact timelines",
          desc: "View every email interaction and relevant activity directly on the contact record.",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "Salesforce integrates with tools like Pardot and Marketing Cloud to deliver enterprise-grade email marketing. It’s built for large organisations needing deep analytics and custom workflows.",
      img: compareItemImg4,
      alt: "Salesforce CRM",
      features: [
        {
          title: "Complex workflow automation",
          desc: "Automate and personalise email journeys using advanced workflow tools and custom triggers.",
        },
        {
          title: "AI-driven insights",
          desc: "Optimise email performance with analytics and suggestions powered by Salesforce Einstein AI.",
        },
        {
          title: "Seamless Salesforce sync",
          desc: "Synchronise email activity with Sales and Service Cloud for a complete customer view.",
        },
      ],
    },
    {
      title: "ActiveCampaign",
      desc: "Known for its strong automation and customer experience tools, ActiveCampaign combines CRM with email marketing in a single platform. It’s especially popular among small-to-medium online businesses.",
      img: compareItemImg5,
      alt: "ActiveCampaign",
      features: [
        {
          title: "Visual automation builder",
          desc: "Design automated emails and workflows using sales and marketing triggers.",
        },
        {
          title: "Lead scoring",
          desc: "Score leads based on email engagement, website activity, and CRM behaviour.",
        },
        {
          title: "Sales-tailored email sequences",
          desc: "Deploy email sequences matched to sales stage, deal activity, or prospect actions.",
        },
      ],
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question: "What are CRM email marketing tools?",
      answer: (
        <>
          CRM email marketing tools like Mailchimp or MailerLite connect your
          marketing software to your CRM, so you can manage campaigns, track
          responses, and personalise communication—all from one place.
        </>
      ),
    },
    {
      question: "How does CRM with email marketing improve lead conversion?",
      answer: (
        <>
          With automated campaigns, better timing, and complete customer
          visibility, you're able to follow up faster and more
          effectively—leading to improved conversion rates.
        </>
      ),
    },
    {
      question: "Is this integration secure?",
      answer: (
        <>
          Yes. Pepper Cloud CRM uses secure API-based connections and complies
          with data protection standards to ensure your contact and campaign
          data is protected.
        </>
      ),
    },
    {
      question: "What is a CRM email marketing integration?",
      answer: (
        <>
          A CRM email marketing integration connects your customer relationship
          management system with your email marketing tool, allowing you to sync
          contact data, automate campaigns, and track performance from one
          place.
        </>
      ),
    },
    {
      question: "Why should I integrate Mailchimp or MailerLite with my CRM?",
      answer: (
        <>
          Integrating tools like Mailchimp or MailerLite with your CRM helps you
          send personalised campaigns, automate outreach based on customer
          behaviour, and get real-time insights into email performance — all
          without manual effort.
        </>
      ),
    },
    {
      question: "What makes Pepper Cloud CRM better than other platforms?",
      answer: (
        <>
          Pepper Cloud offers seamless two-way data sync, advanced segmentation,
          and campaign automation. It combines email activity with sales and
          support data, giving you a complete customer view and stronger
          engagement.
        </>
      ),
    },
    {
      question: "Do I need coding knowledge to set up the integration?",
      answer: (
        <>
          No. Pepper Cloud CRM offers a user-friendly setup process with easy
          field mapping. You can connect Mailchimp or MailerLite by entering
          your API key and configuring preferences — no technical skills
          required.
        </>
      ),
    },
    {
      question: "Can I trigger automated emails based on CRM actions?",
      answer: (
        <>
          Yes. With Pepper Cloud, you can set up workflows that trigger
          Mailchimp or MailerLite campaigns based on CRM actions like new leads,
          deal stage changes, or event signups.
        </>
      ),
    },
    {
      question:
        "Will changes made in Mailchimp or MailerLite reflect in my CRM?",
      answer: (
        <>
          Yes. Pepper Cloud supports two-way synchronisation, which means
          updates made in either system are automatically reflected in the other
          — keeping your data consistent and reliable.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud suitable for growing businesses?",
      answer: (
        <>
          Absolutely. Pepper Cloud is a scalable CRM built for small and
          medium-sized businesses. As your marketing needs grow, it supports
          more advanced workflows, segments, and reporting features without
          complexity.
        </>
      ),
    },
  ];

  const bannerPoints = [
    "CRM with email marketing integration",
    "Real-time campaign performance tracking",
    "Automation that drives conversions",
  ];

  const broadcastList = [
    {
      heading: "Mailchimp CRM integration",
      content:
        "Pepper Cloud offers the best CRM integration for Mailchimp enabling personalised marketing, seamless data sync, and automation to simplify and scale your email efforts with ease.",
      img: broadcastImg1,
      alt: "Mailchimp CRM system integration",
      link: "https://blog.peppercloud.com/mailchimp-crm-integration/",
      background: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      points: [
        "Auto sync contacts with zero manual effort",
        "Map fields to match business workflow needs",
        "Reflect updates instantly across both platforms",
      ],
    },
    {
      heading: "MailerLite CRM integration",
      content:
        "Integrate MailerLite with Pepper Cloud CRM to automate emails, personalise outreach, segment audiences, and make smarter decisions with unified data.",
      img: broadcastImg2,
      alt: "MailerLite with Pepper Cloud CRM integration",
      link: "https://blog.peppercloud.com/mailerlite-crm-integration/",
      background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
      points: [
        "Map MailerLite and CRM fields to match workflows",
        "Automate emails using real-time customer data",
        "Sync data instantly across both platforms seamlessly",
        "View complete customer activity in one dashboard",
      ],
    },
  ];

  return (
    <main>
      <SEO
        keywords="Omnichannel CRM, CRM with WhatsApp integration, CRM for Facebook Messenger, How to integrate WhatsApp with CRM"
        pathname={
          "https://peppercloud.com/user-based-tools/crm-email-marketing-tools-integration/"
        }
        title={"Best CRM email marketing tools | Mailchimp and MailerLite CRM "}
        description={
          "Boost sales and automate email campaigns with Pepper Cloud CRM. Seamlessly integrate Mailchimp or MailerLite to manage contacts, workflows, and results."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What are CRM email marketing tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM email marketing tools like Mailchimp or MailerLite connect your marketing software to your CRM, so you can manage campaigns, track responses, and personalise communication—all from one place.",
                },
              },
              {
                "@type": "Question",
                name: "How does CRM with email marketing improve lead conversion?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "With automated campaigns, better timing, and complete customer visibility, you're able to follow up faster and more effectively—leading to improved conversion rates.",
                },
              },
              {
                "@type": "Question",
                name: "Is this integration secure?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud CRM uses secure API-based connections and complies with data protection standards to ensure your contact and campaign data is protected.",
                },
              },
              {
                "@type": "Question",
                name: "What is a CRM email marketing integration?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A CRM email marketing integration connects your customer relationship management system with your email marketing tool, allowing you to sync contact data, automate campaigns, and track performance from one place.",
                },
              },
              {
                "@type": "Question",
                name: "Why should I integrate Mailchimp or MailerLite with my CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Integrating tools like Mailchimp or MailerLite with your CRM helps you send personalised campaigns, automate outreach based on customer behaviour, and get real-time insights into email performance — all without manual effort.",
                },
              },
              {
                "@type": "Question",
                name: "What makes Pepper Cloud CRM better than other platforms?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud offers seamless two-way data sync, advanced segmentation, and campaign automation. It combines email activity with sales and support data, giving you a complete customer view and stronger engagement.",
                },
              },
              {
                "@type": "Question",
                name: "Do I need coding knowledge to set up the integration?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "No. Pepper Cloud CRM offers a user-friendly setup process with easy field mapping. You can connect Mailchimp or MailerLite by entering your API key and configuring preferences — no technical skills required.",
                },
              },
              {
                "@type": "Question",
                name: "Can I trigger automated emails based on CRM actions?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. With Pepper Cloud, you can set up workflows that trigger Mailchimp or MailerLite campaigns based on CRM actions like new leads, deal stage changes, or event signups.",
                },
              },
              {
                "@type": "Question",
                name: "Will changes made in Mailchimp or MailerLite reflect in my CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud supports two-way synchronisation, which means updates made in either system are automatically reflected in the other — keeping your data consistent and reliable.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud suitable for growing businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Pepper Cloud is a scalable CRM built for small and medium-sized businesses. As your marketing needs grow, it supports more advanced workflows, segments, and reporting features without complexity.",
                },
              },
            ],
          },
        ]}
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
      />
      <section className={classes.SalesRepSection}>
        <div className="carouselContainer">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Best CRM email marketing tools
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Centralise marketing and automate sales with CRM email marketing
                tools like Mailchimp and MailerLite seamless, smart, and
                scalable.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className="parallax-container emailIntegration ">
              <section className="banner-carousel">
                <div className="banner-container">
                  <div className="scroll-container">
                    <div
                      className="logos-row"
                      data-direction="top"
                      data-speed="0.8"
                    >
                      <div className="banner-track">
                        {bannerlogotrack2.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="logos-row"
                      data-direction="bottom"
                      data-speed="0.8"
                    >
                      <div className="banner-track">
                        {bannerlogotrack3.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by leading businesses for outstanding efficiency
          </p>
          <Swiper
            modules={[Autoplay]}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            slidesPerView="auto"
            spaceBetween={30}
            speed={6000} // slow speed for smooth flow
            autoplay={{
              delay: 0, // no delay, continuous movement
              disableOnInteraction: false, // keeps looping even on hover/touch
            }}
            freeMode={true} // allows continuous smooth scroll
            freeModeMomentum={false} // disables snapping effect
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 50,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 100,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 100,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 100,
              },
            }}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black"
            >
              Bring your email marketing and CRM together
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          modules={[Autoplay]}
          speed={5000}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          spaceBetween={30}
          grabCursor={true}
          className={classes.workflowBroadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
              centeredSlides: false,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-regular font-white mt10 mb20">
                  {point.content}
                </p>
                {point.points.map((content) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      alt={"pointer"}
                      className={clsx(classes.cardPointer)}
                    />
                    <p className="font-wix-regular font-18 font-white">
                      {content}
                    </p>
                  </div>
                ))}
                <a
                  className="loginButton font-wix-medium font-16 mt20"
                  href={point.link}
                >
                  Know more
                </a>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.benefitSection2}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is the best CRM with email marketing integration
            </motion.h2>
            {/* <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Using WhatsApp Business Catalog gives your business a competitive
              edge by making product discovery, engagement, and purchase
              seamless—right within a platform your customers already use daily.
            </motion.p> */}
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img src={benefit.icon} alt="Omnichannel CRM" />
                <p className="font-wix-semibold font-24 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 font-black"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Benefits of using CRM with email marketing tools
              </motion.h2>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerRight}>
                <motion.img
                  style={{ width: "100%", height: "100%" }}
                  initial={{ opacity: 1, y: 20 }}
                  src={experienceImg}
                  alt="How to integrate WhatsApp with CRM"
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                />
              </div>
              <div className={classes.experienceContainerLeft} ref={sectionRef}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    className={clsx(
                      classes.faqBoxAccordian,
                      index === activeAccordian && "active",
                      "text-color2"
                    )}
                    key={`faq-${index}-${activeAccordian === index}`}
                    onClick={() => setActiveAccordian(index)}
                    transition={{ duration: 1, delay: index * 0.01 }}
                    whileInView={{ opacity: [0, 1], y: [50, 0] }}
                  >
                    <div className={classes.experienceHeader}>
                      <h3 className="font-20 font-black font-wix-semibold">
                        {faq.title}
                      </h3>
                    </div>
                    <Collapse
                      className={classes.collapseBody}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular font-black exp-desc">
                        {faq.desc}
                      </p>

                      {/* <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={experienceImg}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      /> */}
                    </Collapse>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div
                className="logos-row-2"
                data-direction="left"
                data-speed="0.8"
              >
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo-2 logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row-2"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo-2 logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Top 5 CRM software with email marketing tool integration
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"Email marketing CRM - Frequently asked questions (FAQs)"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Email marketing integration to supercharge your sales
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Show+me+how"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default EmailMarketing;
